import React from "react";
import ReactDOM from "react-dom";
import "./index.less";
import "leaflet/dist/leaflet.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import {HashRouter as Router} from "react-router-dom";
import {MainRouter} from "./router"
import moment from "moment";
import {ConfigProvider} from "antd";
import locale from 'antd/lib/locale/ru_RU';

import 'moment/locale/ru';

moment.locale('ru');



ReactDOM.render(
    <ConfigProvider locale={locale}>
  <Router>
    <App>
      {//<MainRouter></MainRouter>
        }

    </App>
  </Router>
    </ConfigProvider>,
  document.getElementById("root")
); // If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA

serviceWorker.unregister();
